import { useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "@/lib/api";
import { pollingIntervalForDocuments } from "@/hooks/queries/ingestStage";
import { qk } from "@/lib/queryKeys";

export function useStandaloneDocuments(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: qk.standaloneDocs,
    queryFn: () => api.documents.listStandalone(),
    enabled: options?.enabled ?? true,
    refetchInterval: (query) => pollingIntervalForDocuments(query.state.data as Awaited<ReturnType<typeof api.documents.listStandalone>> | undefined),
  });
}

export function useInvalidateStandaloneDocuments() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: qk.standaloneDocs });
}
